export enum ProjectPhaseEnum {
  COMPLETED = 1,
  UNDER_CONSTRUCTION = 5,
}
